import React,{ useRef, useState } from "react";
import { Row,Col,Label } from "reactstrap";
import * as XLSX from "xlsx";
//import XLSX from "xlsx"

export const ExcelImportTool = () => {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [sheetNames, setSheetNames] = useState([]);
    const fileRef = useRef();

    const acceptableFileName = ["xlsx","xls"];
    //File.extension
    //File.Fille.extension 
    const checkFileName = (name) => {
        return acceptableFileName.includes(name.split(".").pop().toLowerCase());
    }

    const handleFile = async (e) => {
        const myFile = e.target.file[0];
        if(!myFile) return;

        if(!checkFileName(myFile.name)){
            alert("Invalid File Type");
            return;
        }
        //Read the xlsx metadata
        const data = await myFile.arrayBuffer();
        const wb = XLSX.read(data);
        console.log(wb);
        //Assign the sheets

        setFile(myFile);
        setFileName(myFile.name);
    };

    const handleRemove = () => {
        setFile(null);
        setFileName(null);
        fileRef.current.value = "";
    }

    return (
        <Row>
            <Col>
                <div className="mb-2"></div>
                {!fileName && <Label>FileName: {fileName}</Label>}
                {!fileName && <Label>Please Upload a File </Label>}
                <div className="">
                    <input
                    type="file"
                    accept="xlsx,xls"
                    multiple={false}
                    onChange={(e) => handleFile(e)}
                    ref={useRef}
                />
                {fileName && (
                <i
                className="now-ui-icons ui-1_simple-remove align-middle"
                onClick={handleRemove} />
                )}

                </div>
            </Col>
        </Row>
    )
}